var baseUrl = 'https://wv.valthea.com/20204';
var shopifyProductId = productData.product.id;
var shopDomain="https://"+Shopify.shop;
var ringDiamondAttribute = null;

function readWooSpecData() {
    var sessionData = {};
    var localData = {};
    try { sessionData = JSON.parse(sessionStorage.getItem("wooSpecData") || "{}"); } catch (e) {}
    try { localData = JSON.parse(localStorage.getItem("wooSpecData") || "{}"); } catch (e) {}
    var mergedData = Object.assign({}, localData, sessionData);
    // ring 是整个定制流程的上下文。session 中可能残留一个不含 ring
    // 或 ring=null 的旧对象，因此这里明确优先保留 localStorage 的有效 ring。
    mergedData.ring = localData.ring || sessionData.ring;
    mergedData.diamond = sessionData.diamond || localData.diamond;
    return mergedData;
}

//fetchProduct().then(data => console.log(data));
function fetchProduct() {
    const url = `${baseUrl}/store/product/details/${shopifyProductId}?shopDomain=${shopDomain}`;
    try {

        return (async () => {
            const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })(); // 立即执行 async 函数
    } catch (error) {
        console.error('POST request error:', error);
        throw error;
    }
    // return woohtml;
}

function caratFormat(value) {
    if (!value) return '0.00';
    var floatPart = '.00'; // 预定义小数部分
    var value2Array = value.toString().split('.');
    // =2表示数据有小数位
    if (value2Array.length === 2) {
        floatPart = value2Array[1]; // 拿到小数部分
        if (floatPart.length === 1) {
            return value2Array[0] + '.' + floatPart + '0';
        } else {
            return value2Array[0] + '.' + floatPart;
        }
    } else {
        return value + floatPart;
    }
}

fetchProduct().then(data => {
    data.product = data.data.product;
    if(data.product.attribute){
        ringDiamondAttribute = data.product.attribute;
        if(ringDiamondAttribute.carat){
            wv$(".diamond-carat").text(caratFormat(ringDiamondAttribute.carat));
        }
       
       wv$(".diamond-color").text(ringDiamondAttribute.color);
        wv$(".diamond-clarity").text(ringDiamondAttribute.clarity);
        wv$(".diamond-cut").text(ringDiamondAttribute.cut);
        var imageUrl = "";
        if(data.product.attribute.imageUrl){
            imageUrl = data.product.attribute.imageUrl
        }else{
            var variant = window.productData.variants[0];
            if(variant.featured_image){
                imageUrl = variant.featured_image.src
            }else{
                if(window.productData.product.featured_image){
                    imageUrl =window.productData.product.featured_image
                }

            }
        }
        if(data.product.attribute.video){
            var  html=`<video preload="auto" autoplay="" loop="" title=""
						poster="${imageUrl}"
						<source src="${data.product.attribute.video}" type="video/mp4">
						playsinline="" webkit-playsinline="" x5-playsinline="" style="width: 100%; height: 100%;">
						</video>`;
            wv$(".image-or-video").html(html);
        }else{
            var html=`<img alt="radiant" loading="lazy" decoding="async" data-nimg="fill" class="z-10 object-cover"
							sizes="100vw" srcset="${imageUrl}&amp;w=576&amp;q=75 576w, ${imageUrl}&amp;w=768&amp;q=75 768w, ${imageUrl}&amp;w=992&amp;q=75 992w, ${imageUrl}&amp;w=1200&amp;q=75 1200w, ${imageUrl}&amp;w=1440&amp;q=75 1440w"
							src="${imageUrl}&amp;w=1440&amp;q=75"
							style="position: absolute; height: 100%; width: 100%; inset: 0px; color: transparent;">`;
            wv$(".image-or-video").html(html);
        }
        var diamondtabitem = wv$(".diamond-tab-item");
        diamondtabitem.removeClass("active");
        for (var i=0;i<diamondtabitem.length;i++){
            var item = wv$(diamondtabitem[i]);
            if(ringDiamondAttribute.color.toLowerCase()==item.text().trim().toLowerCase()){
                //wv$(item).addClass("active");
                wv$(item).click();
                continue;
            }
            if(ringDiamondAttribute.clarity.toLowerCase()==item.text().trim().toLowerCase()){
                //wv$(item).addClass("active");
                wv$(item).click();
                continue;
            }
            if(ringDiamondAttribute.cut.toLowerCase()==item.text().trim().toLowerCase()){
                //wv$(item).addClass("active");
                wv$(item).click();
                continue;
            }
        }

    }


});


wv$(document).on('click', '.tab-button', function() {
    wv$(".bg-content-primary-high").addClass("bg-content-primary-lowest");
    wv$(".bg-content-primary-high").removeClass("bg-content-primary-high");
    wv$(this).addClass("bg-content-primary-high");
    wv$(this).removeClass("bg-content-primary-lowest");
    var index = wv$(this).parent().index();
    wv$(".tabpanel").addClass("hidden");
    var tabpanel_index = wv$(".tabpanel").eq(index);
    
    tabpanel_index.removeClass("hidden");
    if(tabpanel_index.hasClass("tab5_title")){
        if(ringDiamondAttribute!=null && ringDiamondAttribute.pdf && ringDiamondAttribute.pdf.length>0){
            wv$(".image-or-video").hide();
             wv$(".vpdf").show();
            var html = `<iframe src="${ringDiamondAttribute.pdf}" width="100%" id="pdfIframe"  frameborder="0">
                   Your browser does not support iframe or PDF preview. Please <a href="${ringDiamondAttribute.pdf}">download the PDF</a>.
                    </iframe>`;
             wv$(".vpdf").html(html);
        }
         
    }else{
         wv$(".vpdf").hide();
         wv$(".image-or-video").show();
    }
});

wv$(document).on('click', '.close-diamond', function(event) {
    event.preventDefault();
    var destination = '/collections/diamonds';
    try {
        if (document.referrer) {
            var previous = new URL(document.referrer);
            if (previous.origin === window.location.origin && /^\/collections\/[^/]+\/?$/.test(previous.pathname) && /diamond/i.test(previous.pathname)) {
                destination = previous.pathname + previous.search + previous.hash;
            }
        }
    } catch (error) {
        // Fall back to the all-diamonds collection for direct visits.
    }
    window.location.href = destination;
});


wv$(".product-buy-buttons--primary").on("click",function () {
    //window.productData
   //获取商品 id、变体价格、变体id、变体图片（如果没有直接获取商品图片）


    var wooSpecData = readWooSpecData();

    if(wooSpecData.ring && wooSpecData.ring.compatibleShapes && wooSpecData.ring.compatibleShapes.length > 0){
        var normalizeShape = function(shape){
            var normalized = (shape || "").trim().toUpperCase();
            return normalized === "ROUND BRILLIANT" ? "ROUND" : normalized;
        };
        var selectedDiamondShape = normalizeShape(ringDiamondAttribute.shape);
        var compatible = wooSpecData.ring.compatibleShapes.some(function(shape){
            return normalizeShape(shape) === selectedDiamondShape;
        });
        if(!compatible){
            alert("This diamond shape is not compatible with the selected ring.");
            return;
        }
    }

    var variant = window.productData.variants[0];

    wooSpecData.diamond = {
        productId: window.productData.product.id,
        handle: window.productData.product.handle,
        variantId:variant.id,
        price:variant.price,
        cut: ringDiamondAttribute.cut,
        clarity:ringDiamondAttribute.clarity,
        color:ringDiamondAttribute.color,
        shape:ringDiamondAttribute.shape,
        carat:ringDiamondAttribute.carat
    };
    if(ringDiamondAttribute && ringDiamondAttribute.video){
        wooSpecData.diamond.video = ringDiamondAttribute.video
    }
    if(ringDiamondAttribute && ringDiamondAttribute.imageUrl){
        wooSpecData.diamond.featuredImage = ringDiamondAttribute.imageUrl
    }else {
        if(variant.featured_image){
            wooSpecData.diamond.featuredImage = variant.featured_image.src
        }else{
            if(window.productData.product.featured_image){
                wooSpecData.diamond.featuredImage =window.productData.product.featured_image
            }

        }
    }


    var serializedWooSpecData = JSON.stringify(wooSpecData);
    sessionStorage.setItem("wooSpecData", serializedWooSpecData);
    localStorage.setItem("wooSpecData", serializedWooSpecData);
    if(wooSpecData.ring && wooSpecData.ring.productId && wooSpecData.ring.variantId){
        //已选择钻石则跳转到确认页

        window.location.href='/products/diamond-to-setting'
    }else{
        // 钻石优先流程：没有已选戒托时，携带钻石 Shape 前往戒托列表。
        var diamondShape = (ringDiamondAttribute && ringDiamondAttribute.shape
            ? ringDiamondAttribute.shape
            : "").trim();
        var ringParams = new URLSearchParams();
        ringParams.set('flow', 'diamond-first');
        if (diamondShape) ringParams.set('shape', diamondShape);
        window.location.href = '/collections/rings?' + ringParams.toString();
    }


});
function  addToCart(variantId,quantity,properties,callback,errorCallback){

    var formData = {
        'items': [{
            'id': variantId,
            'quantity': quantity,
            'properties':properties
        }]
    };
    wv$.ajax({
        url: window.Shopify.routes.root + 'cart/add.js',
        dataType: "json",
        data: JSON.stringify(formData),
        type: "POST",
        contentType: "application/json;charset=UTF-8",
        async: true,
        beforeSend: function () {},
        success: function (res) {
            callback();
        },error: function (res) {
            if(errorCallback){
            errorCallback(res);
        }},complete: function(res) {}

    });
}

wv$(".purchase-cart").on("click",function () {
    var _this = wv$(this);
    var variant = window.productData.variants[0];
    var properties= {
        "Cut": ringDiamondAttribute.cut,
        "Clarity":ringDiamondAttribute.clarity,
        "Color":ringDiamondAttribute.color,
        "Shape":ringDiamondAttribute.shape
    };
    //添加商品到购物车
    addToCart(variant.id,1,properties,function () {

        setTimeout(function () {
            window.location.href='/cart';
        },3000);


    },function (res) {
        errorMessage(_this,"/collections/diamonds",res.responseJSON.message);
    })

});

function errorMessage(_this,url,text) {
    _this.attr("aria-busy","false");

    var html=`<p class="addtocart-error" style="color:#ef3434;margin-top: 1rem;">${text}
            <a style="text-decoration: underline;color:var(--color-teal)" href="${url}">Reselect‌</a></p>`;
    _this.after(html);
}
